import profile from './profile-pic-settings.svg';
import exit from './icon-Exit.svg';
import edit from './edit-icon.svg';
import sound from './sound-effects-icon.svg';
import training from './training-icon.svg';
import newF from './new-features-icon.svg';

export const settingsIcons = {
    profile,
    exit,
    edit,
    sound,
    training,
    newF
};